module.exports = __webpack_public_path__ + "kw.082e6d77b34e96857a32.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/kw.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/kw.svg
// module chunks = styles